import { useCallback } from "react";
import { useRecoilValue, useResetRecoilState } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { generateRecordKey } from "logic/logics";
import useOpenMeditationRecord from "./useOpenMeditationRecord";
import { MeditationGroupType } from "api/meditationRecordApi";
import { selectedMeditationRecordKeyAtom } from "recoil/selectedMeditationRecordAtom";

export default function useOpenNewMeditationRecord(
  groupType: MeditationGroupType = "routine"
) {
  const patientState = useRecoilValue(patientAtom);
  const resetSelectedMeditationRecordKey = useResetRecoilState(
    selectedMeditationRecordKeyAtom
  );

  const newMeditationRecordKey = generateRecordKey(
    patientState?.patientId!!,
    "meditation"
  );

  const openMeditationRecord = useOpenMeditationRecord(
    newMeditationRecordKey,
    groupType
  );

  return useCallback(() => {
    // Reset any previously selected meditation record before opening a new one
    resetSelectedMeditationRecordKey();
    openMeditationRecord();
  }, [resetSelectedMeditationRecordKey, openMeditationRecord]);
}
